import { render, staticRenderFns } from "./Cloud.vue?vue&type=template&id=00987036&scoped=true"
import script from "./Cloud.vue?vue&type=script&lang=js"
export * from "./Cloud.vue?vue&type=script&lang=js"
import style0 from "./Cloud.vue?vue&type=style&index=0&id=00987036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00987036",
  null
  
)

export default component.exports